import { render, staticRenderFns } from "./plan-templates.vue?vue&type=template&id=fe2807d4"
import script from "./plan-templates.vue?vue&type=script&lang=js"
export * from "./plan-templates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports